import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Animaltools() {
  return (
    <section className="animal-tools p-100">
      <Container>
        <Row className="mb-4 mb-md-5">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2 style={{ color: "#000" }}>
              <span style={{ color: "#00806F" }}>The Tech Behind the Fun</span>:
              Tools & Technologies That Powered Animal Debt Disaster with
              TekRevol
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={11} xl={9} xxl={8} className="m-auto">
            <Row>
              <Col
                xs={12}
                md={4}
                lg={4}
                xl={4}
                xxl={4}
                className="mb-4 mb-md-0"
              >
                <div className="tools-box">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="45"
                      height="45"
                      fill="none"
                      viewBox="0 0 45 45"
                    >
                      <path
                        stroke="#00806F"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M22.711 40.688a18.28 18.28 0 0 0 12.964-5.37 18.28 18.28 0 0 0 5.37-12.963 18.28 18.28 0 0 0-5.37-12.964 18.28 18.28 0 0 0-12.964-5.37 18.28 18.28 0 0 0-12.963 5.37 18.28 18.28 0 0 0-5.37 12.964 18.28 18.28 0 0 0 5.37 12.963 18.28 18.28 0 0 0 12.963 5.37Z"
                      ></path>
                      <path
                        stroke="#00806F"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m15.378 22.356 5.5 5.5 11-11"
                      ></path>
                    </svg>
                  </div>
                  <h5>Frontend</h5>
                  <StaticImage
                    src="../../../images/case-studies/animal-debt/The-Tech-1.webp"
                    alt="TekRevol"
                    className="text-center"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={128}
                    height={179}
                  />
                </div>
              </Col>
              <Col
                xs={12}
                md={4}
                lg={4}
                xl={4}
                xxl={4}
                className="mb-4 mb-md-0"
              >
                <div className="tools-box">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="45"
                      height="45"
                      fill="none"
                      viewBox="0 0 45 45"
                    >
                      <path
                        stroke="#00806F"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M22.711 40.688a18.28 18.28 0 0 0 12.964-5.37 18.28 18.28 0 0 0 5.37-12.963 18.28 18.28 0 0 0-5.37-12.964 18.28 18.28 0 0 0-12.964-5.37 18.28 18.28 0 0 0-12.963 5.37 18.28 18.28 0 0 0-5.37 12.964 18.28 18.28 0 0 0 5.37 12.963 18.28 18.28 0 0 0 12.963 5.37Z"
                      ></path>
                      <path
                        stroke="#00806F"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m15.378 22.356 5.5 5.5 11-11"
                      ></path>
                    </svg>
                  </div>
                  <h5>Backend</h5>
                  <StaticImage
                    src="../../../images/case-studies/animal-debt/The-Tech-2.webp"
                    alt="TekRevol"
                    className="text-center"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={176}
                    height={176}
                  />
                </div>
              </Col>
              <Col xs={12} md={4} lg={4} xl={4} xxl={4} className="">
                <div className="tools-box">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="45"
                      height="45"
                      fill="none"
                      viewBox="0 0 45 45"
                    >
                      <path
                        stroke="#00806F"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M22.711 40.688a18.28 18.28 0 0 0 12.964-5.37 18.28 18.28 0 0 0 5.37-12.963 18.28 18.28 0 0 0-5.37-12.964 18.28 18.28 0 0 0-12.964-5.37 18.28 18.28 0 0 0-12.963 5.37 18.28 18.28 0 0 0-5.37 12.964 18.28 18.28 0 0 0 5.37 12.963 18.28 18.28 0 0 0 12.963 5.37Z"
                      ></path>
                      <path
                        stroke="#00806F"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m15.378 22.356 5.5 5.5 11-11"
                      ></path>
                    </svg>
                  </div>
                  <h5>Cloud Services</h5>
                  <StaticImage
                    src="../../../images/case-studies/animal-debt/The-Tech-3.webp"
                    alt="TekRevol"
                    className="text-center"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={142}
                    height={118}
                  />
                  <p>AWS for scalability and server management</p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Animaltools;
